import type { AppDispatch } from '../store'

import { useDispatch } from 'react-redux'

export const useAppDispatch = () => useDispatch<AppDispatch>()
